import { useQuery } from "@tanstack/react-query";
import { validate } from "uuid";
import { getProduct, getProducts } from "../api";

export const useProducts = (filters) =>
	useQuery({
		queryFn: () => getProducts(filters),
		queryKey: ["products", filters],
	});

export const useProduct = (id) =>
	useQuery({
		queryFn: () => getProduct(id),
		enabled: validate(id),
		queryKey: ["products", { id }],
	});
